import React from 'react'
import TableList from '../../modules/MyProfile/TableToDoList'

const Index = () => {
  return <TableList />
}

export default Index
